import { z } from 'zod';

/**
 * Wire schemas for rating API responses
 * These match the backend response format (snake_case)
 */

/**
 * Menu item rating wire schema (matches backend response format)
 * Based on MenuItemRatingReadSchema from Gateway
 */
export const ratingWireSchema = z.object({
  id: z.number().int(),
  key: z.string(),
  label: z.string(),
});

export type RatingWire = z.infer<typeof ratingWireSchema>;

/**
 * Ratings list response schema
 */
export const ratingsListResponseSchema = z.array(ratingWireSchema);

export type RatingsListResponse = z.infer<typeof ratingsListResponseSchema>;
